import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CONFIG from "../../config";
import { useAuth } from "../../context/AuthProvider";
import { usePatient } from "../../context/PatientContext";
import "../../Styles/addclinic.css";

const AddClinic = () => {
  const [formData, setFormData] = useState({
    CLINIC_NAME: "",
    CLINIC_ADDRESS:"",
    CLINIC_PHONE:"",
  });
  const token = localStorage.getItem("authToken");
  const { verifyTokenAndRedirect } = useAuth();
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;
  const {doctorInfo} = usePatient();

  useEffect(() => {
    verifyTokenAndRedirect();
    console.log(token);
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form data to the backend
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        console.log("sending the request to backend");
         
      await axios.post(`${baseURL}/doctors/addclinic`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,        // 🔐 JWT Token
          doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
          clinicId: doctorInfo.CLINIC_ID,
          roleId: doctorInfo.MANDALI_ROLE
        }
    });
      alert("Clinic Added succesfully");
      navigate("/doctorslist");
    } catch (error) {
      console.error("Error adding CLininc:", error);
      alert("Failed to add Clinic. Please try again.");

    }
  };

  return (
    <div className="add-clinic-container">
      <h2 className="add-clinic-title">Add Clinic</h2>
      <form onSubmit={handleSubmit} className="add-clinic-form">
        <div className="clinic-form-group">
          <label className="clinic-form-label">Clinic Name</label>
          <input
            type="text"
            className="clinic-form-input"
            name="CLINIC_NAME"
            value={formData.CLINIC_NAME}
            onChange={handleChange}
            required
          />
        </div>
  
        <div className="clinic-form-group">
          <label className="clinic-form-label">Clinic Address</label>
          <input
            type="text"
            className="clinic-form-input"
            name="CLINIC_ADDRESS"
            value={formData.CLINIC_ADDRESS}
            onChange={handleChange}
            required
          />
        </div>
  
        <div className="clinic-form-group">
          <label className="clinic-form-label">Clinic Phone No.</label>
          <input
            type="number"
            className="clinic-form-input"
            name="CLINIC_PHONE"
            value={formData.CLINIC_PHONE}
            onChange={handleChange}
            required
          />
        </div>
  
        <div className="clinic-form-group">
          <label className="clinic-form-label">Clinic Logo</label>
          <input
            type="file"
            className="clinic-form-input"
            name="CLINIC_LOGO"
            onChange={handleChange}
            accept="image/*"
          />
        </div>
  
        <div className="clinic-form-actions">
          <button type="submit" className="clinic-btn clinic-btn-submit">Add Clinic</button>
          <button type="button" className="clinic-btn clinic-btn-cancel" onClick={() => navigate("/doctorslist")}>Cancel</button>
        </div>
      </form>
    </div>
  );
}  

export default AddClinic;
